import React, { useEffect, useState } from 'react';
import Video from './video';
import axios from 'axios';

function VideoList() {

    // create state for respnse
    let [allvideos, updateAllvideos] = useState([])

    //use useEffect hook to make api call
    // it alws execute only once (under some circumstance)
    // before view is rendered in browser 
    useEffect(()=>{
        callVideoAPI()
    },[])

    let callVideoAPI=()=>{
        // use axios tp make API CALL
        axios.get(" https://cautious-eel-jacket.cyclic.app/1.0/youtube/all")
                .then((response)=>{
                    console.log("response received in video api call")
                    console.log(response)
                    // transfer response.data to state
                    updateAllvideos(response.data)
                })    
                .catch((error)=>{
                    console.log("error received in video api call")
                    console.log(error)
                })
    }

    // let displayAllVideo=()=>{
    //     return(
    //         <h1>Allvideos from API will render here!</h1>
    //     )
    // } 
    let displayAllVideo=()=>{
        return allvideos.map((video, index)=>{
            return (
                <span>
                    <Video
                    name={video.title}
                    videoid={video.vid}
                    likes={video.likes}
                    dislikes={video.dislikes}
                    color="red"
                    ></Video>
                </span>
            )
        })
    } 
    

    return ( 
        <div>
            <h2>List of video component will come here:</h2>
            <div>All video count:{allvideos.length}</div>
            <div>
                {displayAllVideo()}
            </div>
            <div>
                {/* <Video name="some title 1" 
                    likes="88"
                    dislikes="31"
                    videoid="UE7YOJVSoIs" 
                    color="red"></Video>
                <Video name="some title 2" 
                    likes="818"dislikes="41" 
                    videoid="fNaqHpqMhlI" 
                    color="blue"></Video>
                <Video name="some title 3" 
                    likes="98"
                    dislikes="51"
                    videoid="sDzledM4gIc" color="yellow"></Video>
                <Video name="some title 4" 
                    likes="78"
                    dislikes="27"
                    videoid="EIuV7qGXmpk" 
                    color="green"></Video> */}
            </div>
        </div>
     );
}

export default VideoList;
